"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _types = require("@nicbase/types");

var _nicbaseIcons = require("nicbase-icons");

var _tpmsErrorCodeIcon;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tpmsErrorCodeIcon = (_tpmsErrorCodeIcon = {}, _defineProperty(_tpmsErrorCodeIcon, _types.LatestDataErrorCodeSeverity.Alert, _nicbaseIcons.TPMSAlarm), _defineProperty(_tpmsErrorCodeIcon, _types.LatestDataErrorCodeSeverity.Caution, _nicbaseIcons.TPMSCaution), _defineProperty(_tpmsErrorCodeIcon, _types.LatestDataErrorCodeSeverity.Notification, _nicbaseIcons.TPMSNotification), _defineProperty(_tpmsErrorCodeIcon, _types.LatestDataErrorCodeSeverity.Information, _nicbaseIcons.TPMSNotification), _defineProperty(_tpmsErrorCodeIcon, _types.LatestDataErrorCodeSeverity.Unknown, null), _tpmsErrorCodeIcon);

var tpmsErrorCodeToIcon = function tpmsErrorCodeToIcon(severity) {
  if (!severity || typeof severity !== 'string') return null;
  var icon = tpmsErrorCodeIcon[severity.toUpperCase()];

  if (icon === undefined) {
    console.error("Tpms error code mapping - Missing icon for, ".concat(severity));
    icon = null;
  }

  return icon;
};

var _default = tpmsErrorCodeToIcon;
exports["default"] = _default;